import { DefaultTheme } from 'styled-components'

import { NextModalStyles } from '../../../../../modals/NextModal'

export function deriveModalStyles(theme: DefaultTheme): NextModalStyles {
  return {
    content: {
      backgroundColor: theme.color.deprecated.stoneLighter,
      borderRadius: 0,
      borderWidth: 0,
      bottom: 0,
      left: 0,
      padding: 0,
      right: 0,
      top: 0,
    },
    overlay: {
      background: 'none',
    },
  }
}
